module.exports = __webpack_public_path__ + "img/tutor-dbs-badge.02172ea5.png";